import React from 'react'

import './index.scss'

const Spinner = ({ type = 'white', containerHeigth = "auto" }) => {
  return (
    <div className="spinner__container" style={{ height: containerHeigth }}>
      <div className={`spinner spinner--${type}`}>
        <span className="spinner-inner-1"></span>
        <span className="spinner-inner-2"></span>
        <span className="spinner-inner-3"></span>
      </div>
    </div>
  )
}

export default Spinner